import { render, staticRenderFns } from "./DataSourceList.vue?vue&type=template&id=b9e450c8"
import script from "./DataSourceList.vue?vue&type=script&lang=js"
export * from "./DataSourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9e450c8')) {
      api.createRecord('b9e450c8', component.options)
    } else {
      api.reload('b9e450c8', component.options)
    }
    module.hot.accept("./DataSourceList.vue?vue&type=template&id=b9e450c8", function () {
      api.rerender('b9e450c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/database/datalink/DataSourceList.vue"
export default component.exports